/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MeetingMinuteConsultationAliases {
  AUTOCOMPLETE_PROVIDER = 'autocomplete-provider',
  AVATAR_0 = 'avatar-0',
  CARD_MEETING_MINUTE_CONSULTATION = 'card-meeting-minute-consultation',
  CHECKBOX_0 = 'checkbox-0',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DECK_MEETING_MINUTE_CONSULTATION = 'deck-meeting-minute-consultation',
  FETCH_LOCATOR = 'fetch-locator',
  FETCH_MEETING_MINUTE_CONSULTATION = 'fetch-meeting-minute-consultation',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_PROVIDER = 'field-provider',
  FILTER_MEETING_MINUTE_CONSULTATION = 'filter-meeting-minute-consultation',
  FILTERED_LIST_0 = 'filtered-list-0',
  MAPPER_0 = 'mapper-0',
  MAPPER_AUTOCOMPLETE = 'mapper-autocomplete',
  PANEL_MEETING_MINUTE = 'panel-meeting-minute',
  TEXT_0 = 'text-0',
  TEXT_AUTOCOMPLETE = 'text-autocomplete',
}
export { MeetingMinuteConsultationAliases };
